// @ts-check
import { Path, Svg } from '@react-pdf/renderer';
import React from 'react';

/**
 * An award icon.
 *
 * @param {{  color: string; size: string | number; style?: import('@react-pdf/types').Style }} props
 */
export default function AwardIcon({ color, size, style }) {
  return (
    <Svg viewBox="0 0 20 20" style={[{ width: size }, style]}>
      <Path
        fill={color}
        d="M10.14 3c2.738 0 4.958 2.157 4.958 4.818 0 .913-.261 1.767-.715 2.494l2.557 4.303a.36.36 0 01-.317.544l-.072-.01-1.867-.422a.36.36 0 00-.392.171l-.031.072-.557 1.784a.36.36 0 01-.61.135l-.043-.058-2.502-4.212a5.143 5.143 0 01-.099.007L7.95 16.831a.36.36 0 01-.653-.077l-.557-1.784a.36.36 0 00-.423-.243l-1.867.423a.36.36 0 01-.389-.535l2.232-3.758a4.715 4.715 0 01-1.111-3.04C5.181 5.158 7.401 3 10.14 3zm0 .876c-2.241 0-4.057 1.765-4.057 3.942 0 2.177 1.816 3.941 4.057 3.941 2.24 0 4.057-1.764 4.057-3.941 0-2.177-1.817-3.942-4.057-3.942zm0 2.19c.996 0 1.803.784 1.803 1.752 0 .967-.807 1.752-1.803 1.752-.996 0-1.803-.785-1.803-1.752 0-.968.807-1.752 1.803-1.752z"
      />
    </Svg>
  );
}
